import ControlArea from "components/Layout/ControlArea";
import React from "react";
import { useSelector } from "react-redux";
import blogIcon from "assets/svgs/blog.svg";
import Table from "./Table";
import BootyPagination from "components/shared/Pagination";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { Col, Row } from "react-bootstrap";
import UpdateHeading from "./UpdateHeading";
const Blogs = () => {
  const { works, metadata  ,section} = useSelector((state) => state.works);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  
  return (
    <>
      <div className="stores-wrap">
        <ControlArea
          btnTxt="اضافة عمل"
          cardTxt="الاعمال"
          icon={blogIcon}
          url="/ourWorks/addWork"
        />
        <UpdateHeading/>
       
        <Table data={works} />
        {/* {metadata?.totalResults > 8 && <BootyPagination metaData={metadata} />} */}
      </div>
    </>
  );
};

export default Blogs;
